import classNames from 'classnames'
import { DataModel } from 'legacy/lut/classes/models/DataModel'
import React from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { Grid, Item } from 'core-components/library/grid'

import styles from '../ContactTileCell.module.scss'

import RenderCardHead from './RenderCardHead'
import { renderCardStatusLine } from './tileBlocksMethods'

export default function hpProfileBlock(item: DataModel | IForm) {
  return (
    <Grid className={styles.dataGrid} wrap={'nowrap'}>
      <Item xs={'auto'}>{renderCardStatusLine(item)}</Item>
      <Item xs={'auto'}>
        <span className={classNames(styles.dataIcon, 'hpicon hpicon-profiling')} />
      </Item>
      <Item xs={true}>
        <p className={styles.data}>
          <span className={styles.data__label}>Contact ID:</span>
          <span className={styles.data__value}>{item.get('ContactID')}</span>
        </p>
        <p className={styles.data}>
          <span className={styles.data__label}>LearnerID:</span>
          <span className={styles.data__value}>{item.get('LearnerID')}</span>
        </p>
        <p className={styles.data}>
          <span className={styles.data__label}>User Status:</span>
          <span className={styles.data__value}>{item.get('UserStatus')}</span>
        </p>
        <p className={styles.data}>
          <span className={styles.data__label}>Login ID:</span>
          <span className={styles.data__value}>{item.get('LoginID')}</span>
        </p>
        <p className={styles.data}>
          <span className={styles.data__label}>HP ID:</span>
          <span className={styles.data__value}>{item.get('HPPassportProfileID')}</span>
        </p>
        <p className={styles.data}>
          <span className={styles.data__label}>HPD Contact GUID:</span>
          <span className={styles.data__value}>{item.get('HPD_Contact_GUID')}</span>
        </p>
        <br />
        <p className={styles.data}>
          <span className={styles.data__label}>Country of Business:</span>
          <span className={styles.data__value}>{item.get('CountryOfBusiness')}</span>
        </p>
        <p className={styles.data}>
          <span className={styles.data__label}>Preferred Language:</span>
          <span className={styles.data__value}>{item.get('PreferredLanguage')}</span>
        </p>
      </Item>
      <Item xs={'auto'}>
        <RenderCardHead item={item} />
      </Item>
    </Grid>
  )
}
